import React, { useEffect, useState } from "react";
import axios from "axios";
import "./AddLicense.css";

const AddLicense = ({ isOpen, onClose, onSuccess }) => {
  const [clients, setClients] = useState([]);
  const [servers, setServers] = useState([]);

  const [form, setForm] = useState({
    client_id: "",
    server_id: "",
    license_type: "monthly",
    amount: "",
    start_date: "",
    end_date: "",
    payment_method: "",
    notes: "",
  });

  const [generatedKey, setGeneratedKey] = useState("");

  // =========================
  // LOAD CLIENT + SERVER
  // =========================
  useEffect(() => {
    if (!isOpen) return;

    const loadData = async () => {
      try {
        const [cRes, sRes] = await Promise.all([
          axios.get("https://streamsrvbac.n-tools.info/keymanage/clients/list"),
          axios.get("https://streamsrvbac.n-tools.info/keymanage/server/list"),
        ]);

        setClients(cRes.data || []);
        setServers(sRes.data || []);
      } catch (err) {
        console.error(err);
      }
    };

    loadData();
  }, [isOpen]);

  // =========================
  // HANDLE INPUT
  // =========================
  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  // =========================
  // KEY GENERATOR (FRONT PREVIEW)
  // =========================
  const generatePreviewKey = () => {
    const client = clients.find(c => c.id == form.client_id);
    const server = servers.find(s => s.id == form.server_id);

    if (!client || !server) return;

    const network = (client.network_name || "").substring(0, 4).toUpperCase();
    const machine = (server.machine_id || server.uuid || "").substring(0, 3).toUpperCase();

    const date = new Date().toLocaleDateString("en-GB").replace(/\//g, "");

    const random = Math.random().toString(36).substring(2, 5).toUpperCase();

    const key = random + network + machine + date;

    setGeneratedKey(key);
  };

  // =========================
  // SUBMIT
  // =========================
  const handleSubmit = async () => {
    try {
      const payload = {
        ...form,
        license_key: generatedKey,
      };

      const res = await axios.post(
        "https://streamsrvbac.n-tools.info/keymanage/license/create",
        payload
      );

      alert(res.data.message || "License Created");

      onSuccess?.();
      onClose();

    } catch (err) {
      alert("Failed to create license");
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-box">

        <div className="modal-header">
          <h2>Create License</h2>
          <button onClick={onClose}>✖</button>
        </div>

        {/* CLIENT */}
        <label>Client</label>
        <select name="client_id" onChange={handleChange}>
          <option value="">Select Client</option>
          {clients.map(c => (
            <option key={c.id} value={c.id}>
              {c.name} ({c.network_name})
            </option>
          ))}
        </select>

        {/* SERVER */}
        <label>Server</label>
        <select name="server_id" onChange={handleChange}>
          <option value="">Select Server</option>
          {servers.map(s => (
            <option key={s.id} value={s.id}>
              {s.server_name} ({s.uuid})
            </option>
          ))}
        </select>

        {/* LICENSE TYPE */}
        <label>License Type</label>
        <select name="license_type" onChange={handleChange}>
          <option value="monthly">Monthly</option>
          <option value="lifetime">Lifetime</option>
          <option value="others">Others</option>
        </select>

        <input name="amount" placeholder="Amount" onChange={handleChange} />
        <input type="date" name="start_date" onChange={handleChange} />
        <input type="date" name="end_date" onChange={handleChange} />

        <input name="payment_method" placeholder="Payment Method" onChange={handleChange} />
        <textarea name="notes" placeholder="Notes" onChange={handleChange} />

        {/* KEY GENERATOR */}
        <div className="key-box">
          <p>Generated Key:</p>
          <strong>{generatedKey || "Not generated yet"}</strong>

          <button onClick={generatePreviewKey}>
            Generate Key
          </button>
        </div>

        {/* ACTIONS */}
        <div className="modal-actions">
          <button onClick={handleSubmit}>Create License</button>
        </div>

      </div>
    </div>
  );
};

export default AddLicense;